var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _collapseHeading;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useRef, useState, useEffect } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import ListIcon from '@mui/icons-material/List';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import Drawer from '@mui/material/Drawer';
import Content from './Content';
import Index from './docs/tableOfContents/index.md';

var colors = {
    white: '#ffffff',
    black: '#000000',
    grey1: '#dddddd',
    grey2: '#cccccc',
    grey3: '#F7F7F7',
    teal1: '#037780',
    teal2: '#EAF8FA'
};

var theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920
        }
    },
    typography: {
        allVariants: { color: colors.black },
        fontFamily: 'Open Sans'
    }
});

var guideStyles = {
    indexBox: {
        height: theme.spacing(125),
        backgroundColor: colors.white,
        overflow: 'auto',
        padding: theme.spacing(6, 0, 3),
        marginTop: 3,
        borderRight: theme.spacing(0.125) + ' solid ' + colors.grey1,
        '&::-webkit-scrollbar': {
            width: theme.spacing(0.8)
        },
        '&::-webkit-scrollbar-thumb': {
            background: 'transparent'
        },
        '&:hover': {
            scrollbarColor: 'auto',
            '&::-webkit-scrollbar-thumb': {
                backgroundColor: colors.grey2,
                borderRadius: theme.spacing(0.5)
            }
        }
    },
    mainBox: {
        display: 'flex',
        flexDirection: 'column',
        padding: { xs: theme.spacing(0), md: theme.spacing(8, 0, 10) },
        width: { xs: '100%', md: '78%', lg: '82%' },
        position: 'static'
    },
    contentBox: {
        height: theme.spacing(125),
        backgroundColor: colors.white,
        'user-select': 'text',
        '-webkit-user-select': 'text',
        overflow: 'auto',
        padding: {
            xs: theme.spacing(3) + ' 7.5% ' + theme.spacing(3) + '  7.5%',
            md: theme.spacing(3, 3, 3, 6)
        },
        marginTop: { xs: 0, md: 3 },
        '&::-webkit-scrollbar': {
            width: theme.spacing(0.8)
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: colors.grey2,
            borderRadius: theme.spacing(0.5)
        }
    },
    noPadding: { p: 0, m: 0 },
    noShadow: _defineProperty({}, '& .MuiAccordion-root', {
        borderShadow: 'none'
    }),
    guideTextBox: {
        position: 'fixed',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: colors.white,
        height: theme.spacing(5),
        width: '100%',
        pl: '7.5%'
    },
    guideText: {
        color: colors.teal1,
        textTransform: 'capitalize',
        fontWeight: 550,
        paddingLeft: theme.spacing(2)
    },
    drawer: _defineProperty({
        width: 320,
        pt: 0,
        zIndex: '1000 !important'
    }, '& .MuiDrawer-paper', {
        width: 320,
        pt: 5
    }),
    collapseHeading: (_collapseHeading = {
        display: 'flex',
        flexDirection: 'row-reverse',
        minHeight: theme.spacing(5.75)
    }, _defineProperty(_collapseHeading, '& .MuiAccordionSummary-content', {
        margin: 0
    }), _defineProperty(_collapseHeading, '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded', {
        transform: 'rotate(90deg)'
    }), _collapseHeading),
    mainTitleText: {
        fontSize: theme.spacing(1.75),
        padding: theme.spacing(1.25, 1, 1.25, 2),
        width: '100%'
    },
    headerText1: {
        fontSize: theme.spacing(1.75),
        width: '100%',
        padding: theme.spacing(1.375, 1, 1.375, 1.5)
    },
    headerText2: {
        fontSize: theme.spacing(1.75),
        padding: theme.spacing(1.625, 1, 1.625, 10),
        paddingLeft: 'calc(10% + 40px)',
        cursor: 'pointer'
    },
    subHeaderText: {
        fontSize: theme.spacing(1.75),
        padding: theme.spacing(1.625, 1, 1.625, 11.5),
        cursor: 'pointer'
    },
    tealColor: {
        color: colors.teal1
    },
    collapseArrow: {
        fontSize: theme.spacing(1.6),
        fill: colors.black
    }
};

var Docs = function Docs() {
    var _useState = useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        activeIndex = _useState2[0],
        setActiveIndex = _useState2[1];

    var _useState3 = useState(''),
        _useState4 = _slicedToArray(_useState3, 2),
        content = _useState4[0],
        setContent = _useState4[1];

    var _useState5 = useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isDrawerOpen = _useState6[0],
        setIsDrawerOpen = _useState6[1];

    var boxRef = useRef();
    var inputRef = useRef([]);
    var isScreenSizeMedium = useMediaQuery(theme.breakpoints.up('md'));

    var _useState7 = useState(false),
        _useState8 = _slicedToArray(_useState7, 2),
        mounted = _useState8[0],
        setMounted = _useState8[1];

    var _useState9 = useState({}),
        _useState10 = _slicedToArray(_useState9, 2),
        isOpen = _useState10[0],
        setOpen = _useState10[1];

    var _useState11 = useState({}),
        _useState12 = _slicedToArray(_useState11, 2),
        isSubHeadOpen = _useState12[0],
        setSubHeadOpen = _useState12[1];

    var handleOpen = function handleOpen(id) {
        setOpen(function (prevTruthys) {
            return _extends({}, prevTruthys, _defineProperty({}, id, !isOpen[id]));
        });
    };

    var handleSubHeadOpen = function handleSubHeadOpen(id) {
        setSubHeadOpen(function (prevTruthys) {
            return _extends({}, prevTruthys, _defineProperty({}, id, !isSubHeadOpen[id]));
        });
    };

    // To fetch md files
    var importAll = function importAll(mdFiles) {
        return mdFiles.keys().map(mdFiles);
    };
    var guideFiles = importAll(require.context('./docs', false, /\.(md)$/));

    // To store the contents of index
    if (!mounted) {
        fetch(Index).then(function (res) {
            return res.text();
        }).then(function (text) {
            setContent(text);
        });
    }

    useEffect(function () {
        setMounted(true);
    }, []);
    // Transforming the index content into an array of objects
    var getHeading = function getHeading(inputString, delimiter) {
        var index = inputString.indexOf(delimiter);
        if (index !== -1) {
            return inputString.substring(0, index).trim();
        }
        return inputString.trim();
    };

    var convertStringToArrObj = function convertStringToArrObj(input, id, delimiterArr, idx) {
        var items = input.split(delimiterArr[idx]);
        var arrObjects = [];
        var length = 0,
            tempId = id;
        for (var i = 1; i < items.length; i++) {
            var subItemDetails = idx + 1 < delimiterArr.length ? convertStringToArrObj(items[i], tempId + 1, delimiterArr, idx + 1) : { arrObjects: [], length: 0 };
            arrObjects.push({
                title: idx + 1 < delimiterArr.length ? getHeading(items[i], delimiterArr[idx + 1]) : items[i].trim(),
                id: tempId,
                subItems: subItemDetails.arrObjects
            });
            length += subItemDetails.length + 1;
            tempId = id + length;
        }
        return { arrObjects: arrObjects, length: length };
    };

    var delimiterArr = ['@', '*', '#', '$'];

    // An array of objects containing three level of nesting of headings

    var _convertStringToArrOb = convertStringToArrObj(content, 0, delimiterArr, 0),
        arrObjects = _convertStringToArrOb.arrObjects,
        length = _convertStringToArrOb.length;

    var handleDrawerToggle = function handleDrawerToggle() {
        setIsDrawerOpen(!isDrawerOpen);
    };

    var handleUserNavClick = function handleUserNavClick(id, index) {
        var topHeight = inputRef.current['user-navigation-0'].offsetTop;
        var element = inputRef.current[id];
        boxRef.current.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop - topHeight
        });
        setActiveIndex(index);
        setIsDrawerOpen(false);
    };

    var getSubHeader = function getSubHeader(heading) {
        return React.createElement(
            'div',
            null,
            heading.subItems.length > 0 && React.createElement(
                'div',
                null,
                heading.subItems.map(function (subHeading) {
                    return React.createElement(
                        'div',
                        { key: subHeading.id },
                        subHeading.subItems.length > 0 ? React.createElement(
                            Accordion,
                            {
                                disableGutters: true,
                                elevation: 0,
                                square: true,
                                expanded: isSubHeadOpen[subHeading.id] === true,
                                sx: guideStyles.noShadow
                            },
                            React.createElement(
                                AccordionSummary,
                                {
                                    sx: _extends({}, guideStyles.collapseHeading, {
                                        pl: 'calc(10% + 16px)',
                                        backgroundColor: activeIndex === subHeading.id ? colors.teal2 : '',
                                        '&:hover': {
                                            backgroundColor: activeIndex !== subHeading.id ? colors.grey3 : ''
                                        }
                                    }),
                                    expandIcon: React.createElement(ArrowForwardIosSharpIcon, {
                                        onClick: function onClick() {
                                            return handleSubHeadOpen(subHeading.id);
                                        },
                                        sx: guideStyles.collapseArrow
                                    }),
                                    'aria-controls': 'panel1d-content',
                                    id: 'panel1d-header'
                                },
                                React.createElement(
                                    Typography,
                                    {
                                        variant: 'body2',
                                        sx: guideStyles.headerText1,
                                        onClick: function onClick() {
                                            return handleUserNavClick('user-navigation-' + subHeading.id, subHeading.id);
                                        }
                                    },
                                    subHeading.title
                                )
                            ),
                            React.createElement(
                                AccordionDetails,
                                {
                                    sx: guideStyles.noPadding
                                },
                                React.createElement(
                                    'div',
                                    null,
                                    subHeading.subItems.length > 0 && React.createElement(
                                        'div',
                                        null,
                                        subHeading.subItems.map(function (subHeadingContent) {
                                            return React.createElement(
                                                Accordion,
                                                {
                                                    disableGutters: true,
                                                    elevation: 0,
                                                    square: true,
                                                    expanded: isSubHeadOpen[subHeadingContent.id] === true,
                                                    key: subHeadingContent.id,
                                                    sx: _extends({}, guideStyles.noShadow, {
                                                        '&:before': {
                                                            display: 'none'
                                                        }
                                                    })
                                                },
                                                React.createElement(
                                                    AccordionSummary,
                                                    {
                                                        sx: _extends({}, guideStyles.collapseHeading, {
                                                            pl: 'calc(10% + 32px)',
                                                            backgroundColor: activeIndex === subHeadingContent.id ? colors.teal2 : '',
                                                            '&:hover': {
                                                                backgroundColor: activeIndex !== subHeadingContent.id ? colors.grey3 : ''
                                                            }
                                                        }),
                                                        expandIcon: subHeadingContent.subItems.length > 0 && React.createElement(ArrowForwardIosSharpIcon, {
                                                            onClick: function onClick() {
                                                                return handleSubHeadOpen(subHeadingContent.id);
                                                            },
                                                            sx: guideStyles.collapseArrow
                                                        }),
                                                        'aria-controls': 'panel1d-content',
                                                        id: 'panel1d-header'
                                                    },
                                                    React.createElement(
                                                        Typography,
                                                        {
                                                            variant: 'body2',
                                                            sx: guideStyles.headerText1,
                                                            pl: (subHeadingContent.subItems.length > 0 ? '12px' : '24px') + ' !important',
                                                            onClick: function onClick() {
                                                                return handleUserNavClick('user-navigation-' + subHeadingContent.id, subHeadingContent.id);
                                                            }
                                                        },
                                                        subHeadingContent.title
                                                    )
                                                ),
                                                React.createElement(
                                                    AccordionDetails,
                                                    {
                                                        sx: guideStyles.noPadding
                                                    },
                                                    React.createElement(
                                                        'div',
                                                        null,
                                                        subHeadingContent.subItems.length > 0 && React.createElement(
                                                            'div',
                                                            null,
                                                            subHeadingContent.subItems.map(function (subHeadingContent) {
                                                                return React.createElement(
                                                                    Typography,
                                                                    {
                                                                        variant: 'body2',
                                                                        key: subHeadingContent.id,
                                                                        sx: _extends({}, guideStyles.subHeaderText, {
                                                                            backgroundColor: activeIndex === subHeadingContent.id ? colors.teal2 : '',
                                                                            '&:hover': {
                                                                                backgroundColor: activeIndex !== subHeadingContent.id ? colors.grey3 : ''
                                                                            },
                                                                            paddingLeft: 'calc(10% + 80px)'
                                                                        }),
                                                                        onClick: function onClick() {
                                                                            return handleUserNavClick('user-navigation-' + subHeadingContent.id, subHeadingContent.id);
                                                                        }
                                                                    },
                                                                    subHeadingContent.title
                                                                );
                                                            })
                                                        )
                                                    )
                                                )
                                            );
                                        })
                                    )
                                )
                            )
                        ) : React.createElement(
                            Typography,
                            {
                                variant: 'body2',
                                sx: _extends({}, guideStyles.headerText2, {
                                    backgroundColor: activeIndex === subHeading.id ? colors.teal2 : '',
                                    '&:hover': {
                                        backgroundColor: activeIndex !== subHeading.id ? colors.grey3 : ''
                                    }
                                }),
                                onClick: function onClick() {
                                    return handleUserNavClick('user-navigation-' + subHeading.id, subHeading.id);
                                }
                            },
                            subHeading.title
                        )
                    );
                })
            )
        );
    };

    var tableOfContents = React.createElement(
        Box,
        { sx: guideStyles.indexBox },
        arrObjects.map(function (heading) {
            return React.createElement(
                'div',
                { key: heading.id },
                React.createElement(
                    Accordion,
                    {
                        disableGutters: true,
                        elevation: 0,
                        square: true,
                        expanded: !isOpen[heading.id],
                        sx: guideStyles.noShadow
                    },
                    React.createElement(
                        AccordionSummary,
                        {
                            sx: _extends({}, guideStyles.collapseHeading, {
                                pl: '10%',
                                backgroundColor: activeIndex === heading.id ? colors.teal2 : '',
                                '&:hover': {
                                    backgroundColor: activeIndex !== heading.id ? colors.grey3 : ''
                                }
                            }),
                            expandIcon: React.createElement(ArrowForwardIosSharpIcon, {
                                sx: guideStyles.collapseArrow,
                                onClick: function onClick() {
                                    return handleOpen(heading.id);
                                }
                            }),
                            'aria-controls': 'panel1d-content',
                            id: 'panel1d-header'
                        },
                        React.createElement(
                            Typography,
                            {
                                variant: 'body2',
                                sx: guideStyles.mainTitleText,
                                onClick: function onClick() {
                                    return handleUserNavClick('user-navigation-' + heading.id, heading.id);
                                }
                            },
                            heading.title
                        )
                    ),
                    React.createElement(
                        AccordionDetails,
                        { sx: guideStyles.noPadding },
                        getSubHeader(heading)
                    )
                )
            );
        })
    );
    return React.createElement(
        ThemeProvider,
        { theme: theme },
        content ? React.createElement(
            Box,
            { sx: guideStyles.mainBox },
            React.createElement(
                Grid,
                {
                    container: true,
                    sx: {
                        boxShadow: '0 ' + theme.spacing(0.5) + ' ' + theme.spacing(1) + '  0 \n        #00000026'
                    }
                },
                isScreenSizeMedium ? React.createElement(
                    Grid,
                    { item: true, md: 3 },
                    tableOfContents
                ) : null,
                React.createElement(
                    Grid,
                    { item: true, xs: 12, md: 9 },
                    !isScreenSizeMedium ? React.createElement(
                        Box,
                        { sx: guideStyles.guideTextBox },
                        React.createElement(ListIcon, {
                            sx: guideStyles.tealColor,
                            onClick: handleDrawerToggle
                        }),
                        React.createElement(
                            Typography,
                            { sx: guideStyles.guideText },
                            'GUIDE'
                        )
                    ) : null,
                    React.createElement(
                        Drawer,
                        {
                            variant: 'temporary',
                            anchor: 'left',
                            open: isDrawerOpen,
                            onClose: handleDrawerToggle,
                            sx: guideStyles.drawer
                        },
                        tableOfContents
                    ),
                    React.createElement(
                        Box,
                        { ref: boxRef, sx: guideStyles.contentBox },
                        guideFiles.map(function (value, index) {
                            return React.createElement(
                                Box,
                                {
                                    ref: function ref(element) {
                                        return inputRef.current['user-navigation-' + index] = element;
                                    },
                                    sx: guideStyles.noPadding,
                                    key: 'user-navigation-' + index
                                },
                                React.createElement(Content, { contents: value })
                            );
                        })
                    )
                )
            )
        ) : null
    );
};

export default Docs;